module.exports = __webpack_public_path__ + "images/category_lp/earphone/banner_f63c49cdae0e1291c8a68438e529373d.png";